import React, { useContext } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, useParams } from 'react-router-dom';
import { hasConsent } from './consent';
import { getLanguage, setLanguage } from './language';
import { store } from './store';

const FALLBACK_LANGUAGE = 'pt';

export default (Component) => {
    return () => {
        const { defaultLanguage, setLang } = useContext(store);

        const [cookies, setCookie] = useCookies(['language']);

        const { language } = useParams();
        const history = useHistory();
        const resolvedDefaultLanguage = defaultLanguage || FALLBACK_LANGUAGE;

        /**
         * `language` is a preference cookie, so it may only be written once the
         * visitor has accepted that category. Everything else here works
         * without it: the language lives in the url path, and this cookie only
         * decides where the bare root redirects a returning visitor.
         */
        const rememberLanguage = (lang) => {
            if (hasConsent('preferences')) {
                setCookie('language', lang, { path: '/' });
            }
        };

        const redirectToLanguageHome = (lang) => {
            rememberLanguage(lang);
            setLanguage(lang);
            setLang(lang);
            history.replace(`/${lang}/`);
        };

        if (!language) {
            if (cookies.language) {
                setLanguage(cookies.language);
                setLang(cookies.language);
                history.replace(`/${cookies.language}/`);
            } else if (resolvedDefaultLanguage) {
                redirectToLanguageHome(resolvedDefaultLanguage);
            }
        } else {
            if (!cookies.language) {
                rememberLanguage(language);
            }
            setLanguage(language);
            setLang(language);
        }

        if (getLanguage() !== null) {
            return <Component />
        }

        if (resolvedDefaultLanguage) {
            redirectToLanguageHome(resolvedDefaultLanguage);
        }

        return null;

    }
}
